class _TrackingEvent {
  constructor() {
    this.logEvents = false;
    this.defaultProperties = {};
    this.eventSender = null;
  }

  addEventSender = (eventSender) => {
    this.eventSender = eventSender;
  };

  addDefaultProperties = (properties) => {
    this.defaultProperties = { ...this.defaultProperties, ...properties };
  };

  create = (name, properties = {}) => {
    if (!this.eventSender) {
      console.error('Missing event sender, did addEventSender get removed?');
      return;
    }

    if (this.logEvents) {
      console.log(name, { ...properties, ...this.defaultProperties });
    }

    this.eventSender(name, { ...properties, ...this.defaultProperties });
  };
}

export const TrackingEvent = new _TrackingEvent();
